export function getParam(param) {
    //var url_string = window.location.href;
    var url = new URL(window.location.href);

    return url.searchParams.get(param);        
}

export function getAppDir() {    
    return '/';
}

export function getAppUrl() {
    if (process.env.NODE_ENV === "production")
        return 'https://admin.coletapedido.com.br/';

    return '/';
}

export function getAppUrlApi() {
    if (process.env.NODE_ENV === "production")
        return 'https://admin.coletapedido.com.br/api/';

    return 'http://localhost:81/appshop_admin/api/';
}

export function getAppUrlImg() {
    if (process.env.NODE_ENV === "production")
        return 'https://admin.coletapedido.com.br/img/';

    return 'http://localhost:81/appshop_admin/img/';
}
